import { render, staticRenderFns } from "./ImageAssetCaption.vue?vue&type=template&id=3260e05d&lang=pug&"
import script from "./ImageAssetCaption.vue?vue&type=script&lang=js&"
export * from "./ImageAssetCaption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports